<template>
  <div
    :class="[
      {
        'text-yellow-500': trophyType === 'FIRST',
        'text-zinc-400': trophyType === 'SECOND',
        'text-amber-700': trophyType === 'THIRD',
        'text-stone-500': trophyType === null
      },
      outlined ? '[filter:drop-shadow(0px_2px_2px_rgba(0,0,0,1))]' : ''
    ]"
  >
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 24 24"
      :class="size ?? 'w-6 h-6'"
    >
      <!-- Icon from BoxIcons Solid by Atisa - https://creativecommons.org/licenses/by/4.0/ -->
      <path
        :fill="trophyType ? 'currentColor' : 'none'"
        d="M21 4h-3V3a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1v1H3a1 1 0 0 0-1 1v3c0 4.31 1.8 6.91 4.82 7A6 6 0 0 0 11 17.91V20H9v2h6v-2h-2v-2.09A6 6 0 0 0 17.18 15c3-.1 4.82-2.7 4.82-7V5a1 1 0 0 0-1-1M4 8V6h2v6.83C4.22 12.08 4 9.3 4 8m14 4.83V6h2v2c0 1.3-.22 4.08-2 4.83"
      />
    </svg>
  </div>
</template>

<script setup lang="ts">
defineProps<{
  trophyType: 'FIRST' | 'SECOND' | 'THIRD' | null
  outlined?: boolean
  size?: string
}>()
</script>
